module.exports = __webpack_public_path__ + "img/pendingicon.a4a71f64.png";